import { type AnalyticsEvents, type BaseAnalyticsEvent } from '../types/events'
import { DniAnalytics } from './Analytics'

export interface OmniSegmentCdpConfig {
  measurementId?: string
  userId?: string | null
}

export class OmniSegmentCdp extends DniAnalytics<AnalyticsEvents> {
  readonly config: OmniSegmentCdpConfig
  private static instance: OmniSegmentCdp | null = null

  constructor(config: OmniSegmentCdpConfig) {
    super()
    this.config = config
    this.initialize()
  }

  // Static getInstance method for singleton pattern
  public static getInstance(config: OmniSegmentCdpConfig): OmniSegmentCdp {
    if (!OmniSegmentCdp.instance) {
      OmniSegmentCdp.instance = new OmniSegmentCdp(config)
    }
    return OmniSegmentCdp.instance
  }

  protected initialize(): void {
    if (!this.config.measurementId) {
      console.error('[OmniSegmentCdp] measurementId is not defined')
      return
    }
    this.setIsReady(false)
    const head = document.querySelector('head')
    // https://github.com/omnitag/omnitag/wiki/API#pageview
    const existingScript = document.querySelector('script[src="https://omnitag.omniscientai.com/tag-app.js"]')
    const i13nConfig = {
      tagId: this.config.measurementId,
      uid: this.config.userId,
    }
    window.i13nData = { ...window.i13nData, ...i13nConfig }

    // Only init script once
    if (!existingScript) {
      const script = document.createElement('script')
      script.src = 'https://omnitag.omniscientai.com/tag-app.js'
      script.async = true
      script.onload = () => {
        this.setIsReady(true)
      }
      head?.appendChild(script)
    }
    else {
      this.setIsReady(true)
    }
  }

  protected sendAnalyticsEvent(customEvent: BaseAnalyticsEvent) {
    if (!window.i13n) {
      console.error('[OmniSegmentCdp] i13n is not defined')
      return
    }
    try {
      const { eventName, eventParams } = customEvent
      const cdpEvent = { I13N: { action: eventName, ...eventParams } }
      window.i13n.dispatch?.('action', cdpEvent)
    }
    catch (error) {
      console.error('[CDP] sendEvent', error)
    }
  }
}
